import { Grid } from '@farewill/ui'

import { YES_NO_OPTIONS } from 'utils/enums'
import { ProbateEstate } from 'lib/models/probate-estate'
import {
  POWER_OF_ATTORNEY_SCHEMA,
  TRUSTS_SCHEMA,
} from 'lib/probate/estate-questionnaire-schema'

import Part from '../components/part'
import { QUESTIONNAIRE_SECTIONS } from '../constants'
import RadioGroup from '../components/radio-group'
import EstateFieldsSection from '../components/estate-fields-section'
import { YES_NO_DONT_KNOW_OPTIONS } from '../options'
import useEstateItems from '../estate/use-estate-items'
import Gifts from './gifts'
import Dependents from './dependents'
import AnyOtherNotes from './any-other-notes'

type HandleSave = (event: { name: string; value: unknown }) => void

type Props = {
  probateEstate: ProbateEstate
  saveProbateEstateField: HandleSave
}

const LegalAndFinancial = ({
  probateEstate,
  saveProbateEstateField,
}: Props) => {
  const { attributes } = probateEstate

  const { forType } = useEstateItems({ probateEstateId: probateEstate.id })

  return (
    <Part
      id={QUESTIONNAIRE_SECTIONS.LEGAL_AND_FINANCIAL.id}
      heading={QUESTIONNAIRE_SECTIONS.LEGAL_AND_FINANCIAL.heading}
      description="To understand IHT and any legal or financial matters that the deceased had in place."
    >
      <Gifts
        collection={forType('gift_given')}
        sectionActive={attributes.giftsSectionActive}
        saveProbateEstateField={saveProbateEstateField}
      />
      <EstateFieldsSection
        heading="4.2 Trusts"
        toggleName="trustsSectionActive"
        notesName="trustAssetsNotes"
        fields={['hadRightToBenefitFromTrustAssets', 'wasTrustee']}
        schema={TRUSTS_SCHEMA}
        probateEstate={probateEstate}
        saveProbateEstateField={saveProbateEstateField}
      >
        {(handleSave) => (
          <>
            <Grid.Item span={12}>
              <RadioGroup
                label="Were they benefiting from a trust?"
                name="hadRightToBenefitFromTrustAssets"
                options={YES_NO_DONT_KNOW_OPTIONS}
                handleSave={handleSave}
                inline
              />
            </Grid.Item>
            <Grid.Item span={12}>
              <RadioGroup
                label="Were they a trustee?"
                name="wasTrustee"
                options={YES_NO_OPTIONS}
                handleSave={handleSave}
                inline
              />
            </Grid.Item>
          </>
        )}
      </EstateFieldsSection>
      <Dependents
        sectionActive={attributes.dependentsSectionActive}
        saveProbateEstateField={saveProbateEstateField}
      />
      <EstateFieldsSection
        heading="4.4 Power of Attorney or Court of Protection Deputyship"
        toggleName="powerOfAttorneySectionActive"
        notesName="powerOfAttorneyNotes"
        fields={['hadPowerOfAttorneyOrDeputyship']}
        schema={POWER_OF_ATTORNEY_SCHEMA}
        probateEstate={probateEstate}
        saveProbateEstateField={saveProbateEstateField}
      >
        {(handleSave) => (
          <Grid.Item span={12}>
            <RadioGroup
              label="Did they have a Power of Attorney or Court of Protection Deputyship?"
              name="hadPowerOfAttorneyOrDeputyship"
              options={YES_NO_OPTIONS}
              handleSave={handleSave}
              inline
            />
          </Grid.Item>
        )}
      </EstateFieldsSection>
      <AnyOtherNotes
        probateEstate={probateEstate}
        saveProbateEstateField={saveProbateEstateField}
      />
    </Part>
  )
}

export default LegalAndFinancial
